import axios, { InternalAxiosRequestConfig } from 'axios';
import { pathsMatch } from '../helpers/general';
import { PRIVATE_PATHS } from '../routes/data';

const apiAxios = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api` || 'http://localhost:3001/api',
});

apiAxios.interceptors.response.use(
  res => res,
  async error => {
    const isPrivatePath = PRIVATE_PATHS.find(({ path }) => pathsMatch(`/${path}`, window.location.pathname));
    if (error?.response?.status === 401) {
      if (error?.response?.data?.error?.name === 'TokenExpiredError') {
        const originalRequest = error.config;
        try {
          const refreshToken = localStorage.getItem('refreshToken');
          const response = await apiAxios.post('/auth/refresh-token', {
            refreshToken,
          });
          const { token } = response.data;
          localStorage.setItem('token', token);
          originalRequest.headers.Authorization = token;
          return apiAxios(originalRequest);
        } catch (error) {
          if (isPrivatePath) {
            window.history.pushState({ from: window.location.pathname }, 'Login', '/login');
          }
        }
      } else {
        if (isPrivatePath) {
          window.history.pushState({ from: window.location.pathname }, 'Login', '/login');
        }
      }
    } else {
      return Promise.reject(error);
    }
  },
);

apiAxios.interceptors.request.use(async (req: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('token');
  req.headers.Authorization = token;
  return req;
});

export default apiAxios;
